const fonts = {
  heading: `'Space Grotesk Variable', sans-serif`,
  body: `'Space Grotesk Variable', sans-serif`
};

export default fonts;
